import * as firebase from "firebase";
import api from "./api";

const getTokenFirst = (callback, params) =>
  firebase
    .auth()
    .currentUser.getIdToken()
    .then(idToken => {
      localStorage.setItem("token", idToken);
    })
    .then(() => callback(...params))
    .then(obj => obj)
    .catch(() => []);

export const getMyParts = () => getTokenFirst(api.fetch, ["/parts"]);
export const getPart = (username, partName) =>
  api.fetch(`/parts/${username}/${partName}`);
export const getParts = username => api.fetch(`/parts/${username}`);
export const newPart = data => getTokenFirst(api.post, ["/parts", data]);
export const deletePart = (username, part) =>
  api.post(`/parts/${username}/${part}:delete`);



// WEBPACK FOOTER //
// ./src/util/parts.js